import styled from 'styled-components';
import { FlexBox } from 'src/ui/common/atoms/flex-box';

export const StyledWrapper = styled.div`
  position: relative;
`;

export const StyledDetails = styled(FlexBox)`
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
`;
